import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { TemplateName } from "../../../../../../types/templates/template-name";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlCampaignOverview = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      form={props.form}
      label="Campaign Overview"
      name="campaignOverview"
      required
      subTitle={props.subTitle || TemplateName.CampaignBrief.General}
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
